module.exports = {"default_language":"en","languages_code":["en","ar"],"list":[{"code":"en","name":"english","dir":"ltr"},{"code":"ar","name":"arabic","dir":"rtl"}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/supported_languages.json
// module id = 20
// module chunks = 0